import { render } from "./TableCategories.vue?vue&type=template&id=8648131a"
import script from "./TableCategories.vue?vue&type=script&lang=js"
export * from "./TableCategories.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fahrezibayuprabowo/Documents/project/accessories-cellular-frontend-dev-muped/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__